import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ColorProps, SpaceProps, WidthProps } from 'styled-system';

import { SecondaryButton } from 'components/Button';
import ShowModalContainer from 'containers/ShowModalContainer';
import { colors, mediaRetina } from 'theme';

import ShareIcon from 'share.svg';

const StyledButton = styled(SecondaryButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:hover {
    box-shadow: inset 0 0 0 1px ${colors.battleshipGrey};
    color: ${colors.battleshipGrey};
  }
  ${mediaRetina} {
    &:hover {
      box-shadow: inset 0 0 0 1.5px ${colors.battleshipGrey};
    }
  }

  ${(props) => (props.width ? `width: ${props.width};` : '')}
`;
const StyledShareIcon = styled(ShareIcon)`
  padding-right: 5px;
  * {
    stroke: currentColor;
  }
  ${
    /* sc-selector */
    StyledButton
  }:hover & {
    &:not(:disabled) {
      color: ${colors.turtleGreen};
    }
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ShareListingButton = ({
  iconOnly,
  listing,
  listingType,
  // TODO(Karan): Remove the notion of listingSubType. It's only because IDEALIST_DAY_MAP
  // is inserted into LISTING_TYPE_HUMAN_NAME_MAP. It should not be.
  listingSubType,
  onClick,
  title,
  messageOverride,
  ...props
}: SpaceProps &
  ColorProps &
  WidthProps & {
    blue?: boolean;
    children?: ReactNode;
    disabled?: boolean;
    iconOnly?: boolean;
    listing: {
      id: string;
    };
    listingType: string;
    listingSubType?: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClick?: (...args: Array<any>) => any;
    title?: string;
    size?: 'small' | 'large';
    messageOverride?: string;
  }) => (
  <ShowModalContainer
    render={(showModal) => (
      <StyledButton
        aria-label="Share"
        data-qa-id="share-button"
        onClick={(e) => {
          e.preventDefault();

          if (onClick) {
            onClick();
          }

          showModal('SHARE_LISTING', {
            listingType,
            listingSubType,
            listing,
            title,
            messageOverride,
          });
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <StyledShareIcon width="18" height="18" />
        {!iconOnly && getText('Share')}
      </StyledButton>
    )}
  />
);

export default ShareListingButton;
